export class ViewModelEscolhaPessoa {
  idPessoa: number;
  idPlano: number;
  idPerfilSugerido: number;
  idPerfilEscolhido: number;
  dataResposta: Date;
}
